import React from "react";
import NewsCard from "./NewsCard";
import { Notebook } from "../../normalizer";
import CustomButton from "../../shared/CustomButton";

const NewsFeed = ({ feed }) => {
  return (
    <div className="news-feed">
      <h4 className="news-feed-title">Notícias</h4>

      {!feed || !feed.length ? (
        <div className="news-feed-no-news">Sem notícias</div>
      ) : (
        <div className="news-feed-news-container">
          {feed.map((item) => (
            <NewsCard key={item.id} {...item} />
          ))}
        </div>
      )}
      <div className="news-feed-link">
        <CustomButton link large to={`/news`}>
          <Notebook /> Ver todas
        </CustomButton>
      </div>
    </div>
  );
};
export default NewsFeed;
